export const addNewClass = {
  addNewClass: "Add new class",
  className: "Class name",
  save: "Save",
  grade: "Grade",
  selectClassIcon: "Select class icon",
  sendPaycheckAutomatically:
    "Send paychecks automatically so that you don't forget!",
  sendExpenseAutomatically:
    "Send expenses automatically so that you don't forget!",
  allowYourStudentsToBudgetAndSeeThePowerOfCompoundInterest:
    "Allow your students to budget and set savings goals.",
  roundInterestToNearestWholeNumber: "Round interest to nearest whole number",
  allowStudentsToEarnInterestOnTheirSavings:
    "Allow students to earn interest on their savings.",
  autoPay: "Auto Pay",
  autoExpense: "Auto Expense",
  savingsAccount: "Savings account",
  expensesWillBeSent: "Expenses will be sent",
  salariesWillBeSent: "Salaries will be sent",
  interestWillBeSent: "Interest will be sent",
  grantingInterest: "Granting interest",
  interestRate: "Interest rate (%)",
  exWillRoundTo: "Ex. $5.25 will round to $5",
  classCreatedSucceed: "Class has been created successful",
  editSucceed: "Edit successful",
  mathSettingsSaved: "Math settings saved",
  unsavedChanges: "Unsaved changes",
  unsavedChangesDescription:
    "You have unsaved changes on this tab. Do you want to save them before switching?",
  editClass: "Edit Class",
  selectClass: "Select Class",
  importFrom: "Import from",
  importSettings: "Import settings",
  applySettings: "Apply Settings",
  importantNotice:
    "<strong>Please note:</strong> Importing settings from another class will overwrite all previous settings",
  importSettingsTo: "Import settings to {{className}}",
  whatSettingsWouldYouLikeToImportTo:
    "What settings would you like to import to <strong>{{className}}?</strong>",
  greatSettingsFromClassWillBeImportedToClass:
    "Great! Settings from {{classNameFrom}} will be imported to {{classNameTo}}",
  archiveClass: "Archive Class",
  classHasBeenArchivedSuccessful: "Class has been archived successfully",
  removeClass: "Delete Class",
  classHasBeenDeletedSuccessful: "Class has been deleted successful",
  areYouSureYouWantToDeleteClass:
    "Are you sure you want to delete {{class}} class?",
  areYouSureYouWantToArchiveClass:
    "Are you sure you want to archive {{class}} class?",
  archivingClassWarning:
    "ARCHIVING A CLASS WILL DELETE ALL STUDENTS FROM THIS CLASS. THIS ACTION CANNOT BE UNDONE. ALL STUDENT DATA WILL BE PERMANENTLY DELETED FOR YOU AND ALL OTHER TEACHERS.",
  archivingClassMoveStudentsBefore: "If you do not want to delete students,",
  archivingClassMoveStudentsLink: "move them to another class",
  archivingClassMoveStudentsAfter: "before archiving this class.",
  typeDeleteToConfirmArchive: "Type <bold>\"Delete\"</bold> to confirm",
  deleteConfirmationArchivePlaceholder: "Type Delete here",
  deletingClassWarning:
    "DELETING A CLASS WILL DELETE ALL STUDENTS FROM THIS APPLICATION. THIS ACTION CANNOT BE UNDONE. ALL STUDENT DATA WILL BE PERMANENTLY DELETED FOR YOU AND ALL OTHER TEACHERS.",
  deletingClassMoveStudentsBefore: "If you do not want to delete students,",
  deletingClassMoveStudentsLink: "move them to another class",
  deletingClassMoveStudentsAfter: "before deleting this class.",
  typeDeleteToConfirmDelete: "Type <bold>\"Delete\"</bold> to confirm",
  deleteConfirmationDeletePlaceholder: "Type Delete here",
  youHaveRestoredClassFromTheArchive:
    "You have restored the {{class}} from the archive",
  restoreClass: "Restore {{class}} from archive",
  archivedClasses: "Archived Classes",
  selectOneIcon: "Select one of the possible icons",
  selectOneOption: "Choose one of the options",
  somethingWentWrong: "Something went wrong",
  classWithGivenNameAlreadyExist: "Class with given name already exists",
  allBonusesStoreItemsJobsExpensesAndFinesFromTheSelectedClassWillBeCopied:
    "All bonuses, store items, jobs, expenses and fines from the selected class will be copied.",
  whatClassWouldYouLikeToImportSettingsFrom:
    "What class would you like to import settings from?",
  ChooseWhatKingOfItemsDoYouNeedCopy:
    "Choose what kind of items do you need copy",
  selectAll: "Select all",
  areYouSureYouWantToCopyDB:
    "Are you sure you want copy {{object}} to {{classTitle}}?",
  copyHasBeenSuccesful: "Copy has been successful",
  creatingClass: "Creating class...",
  copyingItems: "Copying items...",
  thisIsListOfStudentsWhoMightLoseTheirJob:
    "This is a list of students who might lose their job:",
  chooseAtLeastOneOfTheOption: "Choose at least one of the option",
  exportStudents: "Export Students",
  thisActionCannotBeUndone:
    "This action cannot be undone. Deleting this class will also delete any settings associated with this class including bonuses, fines, jobs, store items and bills.",
  general: "General",
  advanced: "Advanced",
  showMore: "Show more",
  attendance: "Attendance",
  attendanceTabDescription:
    "By default, this class inherits the school's attendance bonus. Enable the override below to set a class specific amount.",
  attendanceOverride: "Override school default",
  attendanceOverrideTooltip:
    "When unchecked, this class uses the school's default attendance bonus. Check the box to set a custom bonus amount that applies only to this class.",
  attendanceBonusAmount: "Bonus Amount",
  attendanceBonusInherited: "No school attendance bonus has been set.",
  attendanceBonusInvalidAmount:
    "There is a problem displaying the bonus amount. Please contact your school administrator.",
  attendanceBonusSchoolReference: "Using school bonus: {{amount}}",
  attendanceBonusRequired: "Please enter a valid number",
  attendanceBonusMin: "Bonus amount must be 0 or greater",
  descriptionUpgradeTeacherInterest:
    "Interest is a feature included in the 'Pro Subscription' and 'School Subscription'. Learn more about our <Link>paid plans here</Link>. Upgrade to pro or school to unlock this feature.",
  interestOption: "Interest option",
  mathCalculations: "Math calculations",
  manageMathCalculationsForStudents: "Manage math calculations for students",
  checkedStudentsWillBeResponsibleForDoingTheMath:
    "Checked students will be responsible for doing the math to calculate their new balance to make their deposits and withdraws. Uncheck students to opt them out of math calculations.",
  pleaseEnsureStudentsHaveTransitionedAllMoneyFromTheirSavingsToTheirCheckingAccountBeforeTurningOffSavingsAccounts:
    "Please ensure students have transitioned all money from their Savings to their Checking account before turning off Savings accounts.",
  thisClassIsArchived: "This class is archived",
  thisClassIsArchivedDescription:
    "\"{{class}}\" has been archived and is currently inaccessible. You can restore it to regain full access, or go back to your dashboard.",
  archivedOn: "Archived on {{date}}",
  restoreAndOpen: "Restore & Open",
  goBack: "Go Back",
  archivedClassesLabel: "Archived Classes",
  noArchivedClasses: "No archived classes",
  restoreClassQuestion: "Restore class?",
  deleteClassQuestion: "Delete class?",
  restoreClassTooltip: "Restore class",
  deleteClassTooltip: "Delete class",
  confirmRestoreAction: "Confirm restore",
  confirmDeleteAction: "Confirm delete",
  cancelAction: "Cancel",
}
